import { useMemo } from 'react';

import { useCountryCode } from '#src/app/shared/hooks/l10n';
import { useSessionAsync } from '#src/app/shared/hooks/session';
import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = ModelHookResult<{
	isAllowedForLocation: boolean;
}>;

export function useIsAllowedForLocation(): Result {
	const sessionAsync = useSessionAsync();
	const { featureConfigs } = useSessionConfiguration();
	const countryCode = useCountryCode();

	const userStates = isLoaded(sessionAsync) && [
		sessionAsync.value.geoipData.region,
		sessionAsync.value.user?.stateCode,
	];
	const isForbiddenState = userStates
		? userStates.some((code) => code != null && featureConfigs.metaPixelStateBlocklist.includes(code))
		: true;

	const isAllowedForLocation = useMemo(
		// Meta Pixel is currently only enabled on the US, even if the FC supports other countries.
		() => isLoaded(sessionAsync) && !isForbiddenState && countryCode === 'US',
		[sessionAsync, isForbiddenState, countryCode],
	);
	return {
		data: {
			isAllowedForLocation,
		},
	};
}
